export type WorkType = "电影" | "电视剧";
export type RoleType = "主演" | "配角" | "特别出演";

export interface WorkItem {
  id: string;
  title: string;
  year: number;
  type: WorkType;
  roleType: RoleType;
  role: string;
  director: string;
  cover: string;
  rating: number;
  meta: string;
  synopsis: string;
}

export const workTypes: WorkType[] = ["电影", "电视剧"];
export const roleTypes: RoleType[] = ["主演", "配角", "特别出演"];
export const workYears: number[] = [2026, 2025, 2024, 2023, 2022];

export const worksList: WorkItem[] = [
  {
    id: "w1",
    title: "雾港来信",
    year: 2026,
    type: "电视剧",
    roleType: "主演",
    role: "林素（年轻母亲）",
    director: "周慕白",
    cover:
      "https://readdy.ai/api/search-image?query=Minimalist%20movie%20poster%20with%20misty%20harbor%20at%20dusk%2C%20deep%20purple%20and%20warm%20orange%20gradient%2C%20elegant%20negative%20space%2C%20cinematic%20artistic%20composition%2C%20no%20text&width=600&height=900&seq=work-foggy-harbor&orientation=portrait",
    rating: 9.1,
    meta: "24 集 · 都市情感",
    synopsis:
      "以一座临海小城为背景，讲述几段关于亲情、离别与重逢的故事。白石茉莉奈饰演的林素，在生活压力与自我追求之间不断寻找平衡，最终学会与过去和解。",
  },
  {
    id: "w2",
    title: "静水流深",
    year: 2026,
    type: "电影",
    roleType: "主演",
    role: "沈知微（归乡女子）",
    director: "顾维安",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20artistic%20poster%20of%20calm%20river%20reflecting%20soft%20purple%20sky%20at%20golden%20hour%2C%20minimal%20meditative%20composition%2C%20warm%20orange%20light%2C%20elegant%20negative%20space%2C%20no%20text&width=600&height=900&seq=work-still-water&orientation=portrait",
    rating: 8.7,
    meta: "118 分钟 · 文艺剧情",
    synopsis:
      "一位回到故乡处理旧事的女子，在沉默与回忆中重新面对自己的过去。全片台词不多，情绪多由眼神与微表情传递，是一部克制而细腻的文艺作品。",
  },
  {
    id: "w3",
    title: "潮汐之上",
    year: 2026,
    type: "电视剧",
    roleType: "主演",
    role: "江澄（女性创业者）",
    director: "林砚",
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20poster%20of%20powerful%20ocean%20waves%20under%20deep%20purple%20and%20orange%20dusk%20sky%2C%20cinematic%20seascape%2C%20moody%20atmospheric%20artistic%20composition%2C%20no%20text&width=600&height=900&seq=work-above-tide&orientation=portrait",
    rating: 8.9,
    meta: "30 集 · 女性成长",
    synopsis:
      "聚焦女性成长与选择，讲述江澄在事业低谷后重新出发的故事。她并不完美，会害怕也会退缩，但最终选择重新站起来，诠释了真实而坚韧的女性群像。",
  },
  {
    id: "w4",
    title: "长夜将尽",
    year: 2025,
    type: "电影",
    roleType: "主演",
    role: "苏黎（调查记者）",
    director: "韩奕",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20noir%20poster%20of%20rainy%20city%20street%20at%20night%20with%20purple%20neon%20and%20warm%20amber%20lights%2C%20cinematic%20mystery%20atmosphere%2C%20artistic%20reflections%2C%20no%20text&width=600&height=900&seq=work-long-night&orientation=portrait",
    rating: 9.0,
    meta: "126 分钟 · 悬疑剧情",
    synopsis:
      "一名调查记者在追查一桩旧案的过程中，逐渐揭开被时间掩埋的真相。白石茉莉奈在片中展现了极具张力的表演，成为她口碑转型的重要作品。",
  },
  {
    id: "w5",
    title: "春日邮差",
    year: 2025,
    type: "电视剧",
    roleType: "主演",
    role: "许清欢（邮局职员）",
    director: "叶知行",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20gentle%20poster%20of%20spring%20countryside%20path%20with%20blossoms%2C%20soft%20purple%20pink%20sky%2C%20cozy%20hopeful%20atmosphere%2C%20minimal%20artistic%20composition%2C%20no%20text&width=600&height=900&seq=work-spring-postman&orientation=portrait",
    rating: 8.4,
    meta: "20 集 · 治愈生活",
    synopsis:
      "小镇邮局的日常里，藏着一封封没有寄出的信。许清欢用最朴素的方式，帮每个陌生人传递心里的话，也在过程中治愈了自己。",
  },
  {
    id: "w6",
    title: "浮城旧梦",
    year: 2024,
    type: "电影",
    roleType: "主演",
    role: "纪南音（歌女）",
    director: "顾维安",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20cinematic%20poster%20of%20old%20city%20skyline%20at%20nightfall%2C%20deep%20purple%20blue%20and%20warm%20orange%20glow%2C%20nostalgic%20elegant%20artistic%20composition%2C%20no%20text&width=600&height=900&seq=work-floating-city&orientation=portrait",
    rating: 8.6,
    meta: "132 分钟 · 年代剧情",
    synopsis:
      "一座浮华的城市，一段被歌声记住的旧梦。纪南音在时代洪流中努力守住自己的坚持，也付出沉重的代价。",
  },
  {
    id: "w7",
    title: "山与光",
    year: 2024,
    type: "电视剧",
    roleType: "特别出演",
    role: "支教老师 白晴",
    director: "沈川",
    cover:
      "https://readdy.ai/api/search-image?query=Serene%20poster%20of%20misty%20mountains%20at%20dawn%20with%20soft%20golden%20sunrise%20and%20purple%20haze%2C%20hopeful%20uplifting%20atmosphere%2C%20minimal%20artistic%20composition%2C%20no%20text&width=600&height=900&seq=work-mountain-light&orientation=portrait",
    rating: 8.8,
    meta: "28 集 · 现实题材",
    synopsis:
      "一位支教老师走进深山，用一束光点亮孩子们的未来。白石茉莉奈特别出演白晴一角，戏份不多却令人难忘。",
  },
  {
    id: "w8",
    title: "第二次告白",
    year: 2023,
    type: "电影",
    roleType: "主演",
    role: "温念（编剧）",
    director: "苏念安",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20minimal%20poster%20with%20soft%20sunset%20gradient%20in%20warm%20orange%20and%20muted%20purple%2C%20elegant%20cinematic%20composition%2C%20gentle%20tender%20mood%2C%20no%20text&width=600&height=900&seq=work-second-confession&orientation=portrait",
    rating: 8.1,
    meta: "108 分钟 · 爱情剧情",
    synopsis:
      "一位习惯把感情写进剧本的编剧，却在现实里始终说不出那句话。关于错过与重逢，关于勇气与时间。",
  },
  {
    id: "w9",
    title: "沉默的证词",
    year: 2023,
    type: "电视剧",
    roleType: "配角",
    role: "检察官 顾岚",
    director: "韩奕",
    cover:
      "https://readdy.ai/api/search-image?query=Serious%20drama%20poster%20with%20abstract%20geometric%20shapes%20in%20deep%20purple%20and%20cool%20blue%2C%20restrained%20cinematic%20composition%2C%20subtle%20warm%20accent%2C%20no%20text&width=600&height=900&seq=work-silent-proof&orientation=portrait",
    rating: 8.5,
    meta: "32 集 · 犯罪悬疑",
    synopsis:
      "一桩看似简单的案件背后，是层层被隐藏的真相。顾岚作为检察官，在情与法之间寻找那条最难走的路。",
  },
  {
    id: "w10",
    title: "向晚的城市",
    year: 2022,
    type: "电影",
    roleType: "特别出演",
    role: "咖啡店店主",
    director: "叶知行",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20city%20skyline%20at%20sunset%20with%20soft%20purple%20and%20orange%20tones%2C%20cozy%20urban%20melancholy%2C%20minimal%20artistic%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=work-evening-city&orientation=portrait",
    rating: 7.9,
    meta: "96 分钟 · 都市剧情",
    synopsis:
      "城市向晚时分，一家小咖啡店收留了几个不愿回家的人。店主安静地听着每个人的故事，也藏着自己的往事。",
  },
  {
    id: "w11",
    title: "青禾",
    year: 2022,
    type: "电视剧",
    roleType: "配角",
    role: "农技员 何青",
    director: "沈川",
    cover:
      "https://readdy.ai/api/search-image?query=Fresh%20rural%20poster%20with%20green%20fields%20under%20soft%20purple%20dusk%20sky%2C%20calm%20hopeful%20atmosphere%2C%20minimal%20natural%20artistic%20composition%2C%20no%20text&width=600&height=900&seq=work-green-sprout&orientation=portrait",
    rating: 8.2,
    meta: "26 集 · 乡土现实",
    synopsis:
      "一群年轻人回到乡村，用新技术改变家乡。何青从最初的不被理解，到最终成为乡亲们最信任的人。",
  },
  {
    id: "w12",
    title: "午夜书店",
    year: 2025,
    type: "电影",
    roleType: "配角",
    role: "店主 林晚",
    director: "苏念安",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20bookstore%20interior%20at%20midnight%20with%20warm%20lamp%20light%20and%20soft%20purple%20shadow%2C%20intimate%20quiet%20atmosphere%2C%20minimal%20artistic%20composition%2C%20no%20text&width=600&height=900&seq=work-midnight-bookstore&orientation=portrait",
    rating: 8.3,
    meta: "102 分钟 · 治愈剧情",
    synopsis:
      "只在午夜营业的书店，收留每一个无处可去的人。店主林晚相信，总有一本书，会等到对的人。",
  },
];